module.exports = __webpack_public_path__ + "fonts/1feee13e-ded1-4d73-9d76-c5ed16a43117.27350a77.woff";